import React from 'react';
import cn from 'classnames';
import Img from 'gatsby-image';

const Background = ({ src, alt = '', className, blur = false }) => {
  return (
    <div className={cn('w-full h-full absolute top-0 left-0 -z-10', className)}>
      <Img fluid={src} className='w-full h-full'
           imgStyle={{ objectPosition: 'top' }} alt={alt} />
      {blur && <div className='w-full h-full bg-[#FFD33A] bg-opacity-75 absolute top-0 left-0' />}
    </div>
  );
};

export default Background;
